import { useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Map as MapIcon,
  Globe,
  Database,
  AlertTriangle,
  Workflow,
  ShieldHalf,
  Brain,
  ClipboardCheck,
  Settings,
} from 'lucide-react';
import { Tooltip } from '@/components';
import './shell.css';

const ITEMS = [
  { to: '/', icon: LayoutDashboard, label: 'National COP', shortcut: '1' },
  { to: '/map', icon: MapIcon, label: 'Map (Common Operating Picture)', shortcut: '2' },
  { to: '/assets', icon: Database, label: 'Assets & Digital Twins', shortcut: '3' },
  { to: '/alerts', icon: AlertTriangle, label: 'Alerts & Incidents', shortcut: '4' },
  { to: '/scenarios', icon: Workflow, label: 'Scenarios & Simulation', shortcut: '5' },
  { to: '/ot', icon: ShieldHalf, label: 'OT Monitoring', shortcut: '6' },
  { to: '/intel', icon: Brain, label: 'Intelligence & KG', shortcut: '7' },
  { to: '/compliance', icon: ClipboardCheck, label: 'Compliance', shortcut: '8' },
  { to: '/globe', icon: Globe, label: '3D Globe', shortcut: '9' },
];

export function NavSidebar() {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement)
        return;
      const tag = e.key;
      const item = ITEMS.find((i) => i.shortcut === tag);
      if (item) {
        e.preventDefault();
        navigate(item.to);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);

  return (
    <nav className="iris-nav">
      <ul>
        {ITEMS.map(({ to, icon: Icon, label, shortcut }) => (
          <li key={to}>
            <Tooltip
              side="right"
              content={
                <span>
                  {label} <span className="iris-kbd-hint">[{shortcut}]</span>
                </span>
              }
            >
              <NavLink
                to={to}
                className={({ isActive }) =>
                  `iris-nav-item${isActive ? ' active' : ''}`
                }
              >
                <Icon size={20} strokeWidth={1.5} />
              </NavLink>
            </Tooltip>
          </li>
        ))}
      </ul>
      <div className="iris-nav-bottom">
        <Tooltip side="right" content="Settings">
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              `iris-nav-item${isActive ? ' active' : ''}`
            }
          >
            <Settings size={20} strokeWidth={1.5} />
          </NavLink>
        </Tooltip>
      </div>
    </nav>
  );
}
